import { UniversalSearchInput } from './UniversalSearchInput';
import { UniversalSearchContent } from './UniversalSearchContent';
import { useObjectListUniversalSearch } from '../object-list/useObjectListUniversalSearch';
import { DialogLoader } from '../../common/dialogs/DialogLoader';
import { SearchFullViewLayout } from '../building-blocks/search/SearchFullViewLayout';

interface UniversalSearchProps {
  crmOrgId: string;
  isExpandedMode?: boolean;
}

export const UniversalSearch = ({ crmOrgId, isExpandedMode }: UniversalSearchProps) => {
  const {
    searchTxt,
    tempSearchTxt,
    onSearchChange,
    onClearButtonClick,
    onSelectedFilterItem,
    isSearchListOpen,
    results,
    isLoadingResults,
    isLoadingDependency,
    onListItemClick,
    searchTypeOptions,
    selectedSearchType,
    onSelectSearchTypeOption,
    handleCloseUniversalSearch,
    onSearchKeydownWithEscHandler,
    filterOptions,
    selectedFilterValue,
  } = useObjectListUniversalSearch({
    crmOrgId,
  });

  const searchInput = (
    <UniversalSearchInput
      searchTxt={searchTxt}
      tempSearchTxt={tempSearchTxt}
      onKeyDown={onSearchKeydownWithEscHandler}
      onChange={onSearchChange}
      onClearButtonClick={onClearButtonClick}
      filterOptions={filterOptions}
      onSelectedFilterItem={onSelectedFilterItem}
      selectedFilterValue={selectedFilterValue}
      isSearchListOpen={isSearchListOpen}
      isExpandedMode={isExpandedMode}
      searchInputSize="default"
      menuOptions={searchTypeOptions}
      selectedMenuOption={selectedSearchType}
      onSelectMenuOption={onSelectSearchTypeOption}
    />
  );

  return (
    <SearchFullViewLayout
      isExpandedMode={isExpandedMode ?? false}
      searchInput={searchInput}
      onClose={isExpandedMode ? handleCloseUniversalSearch : undefined}
    >
      <DialogLoader visible={isLoadingDependency} />
      <UniversalSearchContent
        onListItemClick={onListItemClick}
        showLoader={false}
        results={results}
        isLoadingResults={isLoadingResults}
        crmOrgId={crmOrgId}
        filterOptions={filterOptions}
        onSelectedFilterItem={onSelectedFilterItem}
        selectedFilterValue={selectedFilterValue}
        isExpandedMode={isExpandedMode || false}
      />
    </SearchFullViewLayout>
  );
};
